import { Pipe, PipeTransform } from "@angular/core";
import { obtenerNombreTipoAccion, TipoAccionesEnum } from "@shared/enums";

@Pipe({
    name: "nombreTipoAccion"
})
export class NombreTipoAccionPipe implements PipeTransform {

    transform(tipo: TipoAccionesEnum): string {
        return obtenerNombreTipoAccion(tipo);
    }

}
